import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Ship, Gauge, Fuel, Wrench } from "lucide-react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { images, segments } from "../mock/mock";

const features = [
  { icon: Gauge, title: "Efficiency", desc: "An optimal balance between power output and fuel consumption." },
  { icon: Fuel, title: "Fuel Flexibility", desc: "Liquid and gas platforms ready for the fuels of the future." },
  { icon: Ship, title: "Reliability", desc: "Built to withstand the rigours of continuous operation at sea." },
  { icon: Wrench, title: "Low Maintenance", desc: "Robust construction that keeps total cost of ownership down." },
];

export default function AtSea() {
  return (
    <main>
      <PageHero image={images.atSea} eyebrow="Solutions" title="At Sea." subtitle={segments.atSea.body} />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
          <div className="grid md:grid-cols-2 gap-14 items-center">
            <img src={images.tanker} alt="Marine vessel" className="rounded-lg w-full h-[420px] object-cover shadow-xl" />
            <div>
              <h2 className="oe-heading text-oe-navy text-3xl md:text-4xl mb-6">Favoured in marine applications</h2>
              <div className="space-y-6">
                {features.map((f) => (
                  <div key={f.title} className="flex gap-4">
                    <div className="w-12 h-12 shrink-0 rounded-lg bg-secondary flex items-center justify-center">
                      <f.icon size={22} className="text-oe-navy" />
                    </div>
                    <div>
                      <h3 className="text-oe-navy font-semibold text-lg">{f.title}</h3>
                      <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/products" className="group inline-flex items-center gap-3 mt-10 oe-navy text-white font-semibold px-8 py-4 rounded-md hover:oe-navy-2 transition-colors">
                View marine engines <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
